import { CampaignSubmitResponse } from '@features/campaigns/shared/types/campaignSubmit.ts';
import { ListThematicPackagesResponse } from '@features/campaigns/shared/types/thematicPackage.ts';
import { mockedCampaignDetails } from '@shared/mocks/requests/campaignDetails/campaignDetails.fixtures';

export const mockedThematicPackages: ListThematicPackagesResponse = {
  items: [
    {
      id: '8485618b-af80-41cc-9f93-313c46a68075',
      name: 'Cucina',
      sites: {
        primary: { name: 'cucina-site1', domain: 'cucina-site1.it', logoUrl: 'https://placehold.co/100x50' },
        secondary: [
          { name: 'cucina-site2', domain: 'cucina-site2.it', logoUrl: 'https://placehold.co/50' },
          { name: 'cucina-site3', domain: 'cucina-site3.it', logoUrl: 'https://placehold.co/50' },
        ],
      },
    },
    {
      id: 'b4fea8eb-05e3-4bf0-9a35-f4e67f0f83e7',
      name: 'Lifestyle',
      sites: {
        primary: { name: 'lifestyle-site1', domain: 'lifestyle-site1.it', logoUrl: 'https://placehold.co/100x50' },
        secondary: [{ name: 'lifestyle-site2', domain: 'lifestyle-site2.it', logoUrl: 'https://placehold.co/50' }],
      },
    },
  ],
};

export const mockedCreatedThematicPackageCampaign: CampaignSubmitResponse['campaign'] = {
  ...mockedCampaignDetails,
  id: '9f8e7d6c-0009-4a1b-9c2d-900000000009',
  name: 'S-000123 - Cucina',
};
